"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Renderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const client_1 = require("react-dom/client");
exports.Renderer = new (class {
    render(applicationHead, applicationContainer, Application) {
        (0, client_1.createRoot)(applicationContainer).render((0, jsx_runtime_1.jsx)(Application, { styleContainer: applicationHead }));
    }
})();
